import { UserService } from '../../../../shared/services';
import { DateRange } from '../../../../shared/models';
import { SheetComponent, LocationPickerComponent } from '../../../../shared/ui';
import { Component, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { LocationsFilter } from '../../models';


@Component({
    selector: 'locations-filter-sheet',
    template: require('./locations-filter-sheet.component.pug')
})
export class LocationsFilterSheetComponent {
    @Input() fg: FormGroup;
    @Input() filter: LocationsFilter;

    @Output() filterChanged = new EventEmitter<LocationsFilter>();

    @ViewChild(SheetComponent) sheet;
    @ViewChild(LocationPickerComponent) locationPicker;

    dateOptions = ['Today', 'Custom Range'];
    activeOption: string;
    showDateRange: boolean;

    private IsValidDateRange: boolean;

    constructor(private _userSvc: UserService) {
        this.activeOption = this.dateOptions[0];
    }

    locationPickerReady() {
        this.applyFilter(null);
    }

    toggle() {
        this.sheet.toggle();
    }

    onDateOptionSelected(option: string) {
        this.showDateRange = option === 'Custom Range';
    }

    applyFilter(e: MouseEvent) {
        if (e) {
            e.preventDefault();
        }
        let value = this.fg.value;

        let dateRange = this.showDateRange ?
            new DateRange(value.from, value.to)
            : new DateRange();

        this.IsValidDateRange = dateRange.isValid;

        if (this.IsValidDateRange) {
            let locationsPickerSelection = this.locationPicker.getSelection();

            let filter = new LocationsFilter(
                dateRange,
                locationsPickerSelection,
                value.filter);

            setTimeout(() => this.filterChanged.emit(filter), 10);
        }
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/location/shared/ui/locations-filter-sheet/locations-filter-sheet.component.ts